import axios from "axios";
import authHeader from "./authHeader";
import { apiPath, API_URL } from "./apiPath";
import constData from "../components/ReusableComponents/constants";
const addWorkerDetails = (workerDetails) => {
  return axios
    .post(
      API_URL + apiPath.addWorker,
      workerDetails,
      authHeader(constData.allPermissions.addWorker)
    )
    .then((response) => {
      return response.data;
    });
};
const inviteWorkerApi = (workerDetails) => {
  return axios
    .post(API_URL + apiPath.inviteWorker, workerDetails, authHeader())
    .then((response) => {
      return response.data;
    });
};
const updateWorkerDetails = (workerDetails) => {
  return axios
    .post(
      API_URL + apiPath.updateWorker,
      workerDetails,
      authHeader(constData.allPermissions.editWorker)
    )
    .then((response) => {
      return response.data;
    });
};

const changeWorkerStaus = (params) => {
  return axios
    .post(
      API_URL + apiPath.changeWorkerStatus,
      params,
      authHeader(constData.allPermissions.workerChangeStatus)
    )
    .then((response) => {
      return response.data;
    });
};

const updateWorkerDetailsExp = (expDetails) => {
  return axios
    .post(API_URL + apiPath.updateWorkerExp, expDetails, authHeader())
    .then((response) => {
      return response.data;
    });
};

const addOrInviteWorker = {
  addWorkerDetails,
  inviteWorkerApi,
  changeWorkerStaus,
  updateWorkerDetails,
  updateWorkerDetailsExp,
};

export default addOrInviteWorker;
